/** One ring of a reach glyph: its path on the 32×32 grid and how densely it fills. */
export type TraveltimeRing = { d: string; fillOpacity: number }
/** How many rings a reach glyph can wear: one per search, up to four. */
export type TraveltimeIsochroneRings = 1 | 2 | 3 | 4
export const TRAVELTIME_ISOCHRONE_MAX_RINGS: TraveltimeIsochroneRings = 4

const OUTER_PATH =
  "M15 3.5L22 6L25.5 10.5L28.5 12.5L27 18.5L28 23L23 25.5L19 29L14 27.5L8.5 26.5L7 21.5L8 17L4 11.5L8 8L11 6.5L15 3.5Z"

/**
 * The nested reach polygons, one to four, outer first and each filling
 * denser than the one around it, so the nesting reads in one colour. The
 * outer ring is the same in every count; the inner ones are the outer
 * scaled towards the centre.
 */
export const TRAVELTIME_ISOCHRONE_RINGS: Record<
  TraveltimeIsochroneRings,
  readonly TraveltimeRing[]
> = {
  1: [{ d: OUTER_PATH, fillOpacity: 0.35 }],
  2: [
    { d: OUTER_PATH, fillOpacity: 0.3 },
    {
      d: "M15.4499 9.12012L19.2999 10.5001L21.2299 12.9701L22.8799 14.0701L22.0499 17.3801L22.5999 19.8501L19.8499 21.2301L17.6499 23.1501L14.8999 22.3201L11.8799 21.7701L11.0499 19.0201L11.5999 16.5501L9.3999 13.5301L11.5999 11.6001L13.2499 10.7701L15.4499 9.12012Z",
      fillOpacity: 0.55,
    },
  ],
  3: [
    { d: OUTER_PATH, fillOpacity: 0.3 },
    {
      d: "M15.3401 7.75L19.9601 9.4L22.2701 12.37L24.2501 13.69L23.2601 17.65L23.9201 20.62L20.6201 22.27L17.9801 24.58L14.6801 23.59L11.0501 22.93L10.0601 19.63L10.7201 16.66L8.08008 13.03L10.7201 10.72L12.7001 9.73L15.3401 7.75Z",
      fillOpacity: 0.45,
    },
    {
      d: "M15.6599 11.75L18.0399 12.6L19.2299 14.13L20.2499 14.81L19.7399 16.85L20.0799 18.38L18.3799 19.23L17.0199 20.42L15.3199 19.91L13.4499 19.57L12.9399 17.87L13.2799 16.34L11.9199 14.47L13.2799 13.28L14.2999 12.77L15.6599 11.75Z",
      fillOpacity: 0.6,
    },
  ],
  4: [
    { d: OUTER_PATH, fillOpacity: 0.25 },
    {
      d: "M15.25 6.62012L20.5 8.50012L23.12 11.8801L25.38 13.3801L24.25 17.8801L25 21.2501L21.25 23.1201L18.25 25.7501L14.5 24.6201L10.38 23.8801L9.25 20.1201L10 16.7501L7 12.6201L10 10.0001L12.25 8.88012L15.25 6.62012Z",
      fillOpacity: 0.35,
    },
    {
      d: "M15.5 9.75L19 11L20.75 13.25L22.25 14.25L21.5 17.25L22 19.5L19.5 20.75L17.5 22.5L15 21.75L12.25 21.25L11.5 18.75L12 16.5L10 13.75L12 12L13.5 11.25L15.5 9.75Z",
      fillOpacity: 0.5,
    },
    {
      d: "M15.7298 12.6201L17.6198 13.3001L18.5698 14.5201L19.3798 15.0501L18.9698 16.6801L19.2398 17.8901L17.8898 18.5701L16.8098 19.5101L15.4598 19.1101L13.9698 18.8401L13.5698 17.4801L13.8398 16.2701L12.7598 14.7901L13.8398 13.8401L14.6498 13.4301L15.7298 12.6201Z",
      fillOpacity: 0.65,
    },
  ],
}
